<template>
  <SplashPage msg="Welcome to Your Vue.js + TypeScript App"/>
</template>

<script setup lang="ts">
window.location.href = 'https://shop.simbastickers.com';   // We want to do it immediately.

import SplashPage from './components/SplashPage.vue';

</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;

  h1 {
    margin-top: -20px;
  }

  p {
    margin: 0.5rem 0;
  }
}
</style>
